import React from "react";
import { Box, Toolbar } from "@mui/material";
import { Header, Sidebar } from '../components';
import { colors } from "../utils/theme";
import { Routes, Route } from 'react-router-dom';
import Orderlist from "../features/orderList";
import Productlist from "../features/productList";
import CustomerList from "../features/customerList";
import CustomerProduct from "../features/customerProduct";
import CustomerShip from "../features/customerShipList";
import OrderCsv from "../features/orderCsv";
import CalendarSetting from "../features/calendarSetting";
import OrderDetail from "../features/orderList/orderDetail";
import DeliveryList from "../features/deliveryList";
import { routingPath } from "../utils/path";

export default function MainPage() {
  return (
    <>
      <Header isLoggedIn={true}/>
      <Box sx={{ display: 'flex' }}>
        <Sidebar />
        <Box sx={{ flexGrow: 1, bgcolor: colors.backGroundColor, minHeight: '100vh' }}>
          <Toolbar />
          <Routes>
            <Route path={routingPath.orderList} element={<Orderlist />} />
            <Route path={`${routingPath.orderList}/:orderId`} element={<OrderDetail />} />
            <Route path={routingPath.orderCsv} element={<OrderCsv />} />
            <Route path={routingPath.productList} element={<Productlist />} />
            <Route path={routingPath.customerList} element={<CustomerList />} />
            <Route path={routingPath.customerProductList} element={<CustomerProduct />} />
            <Route path={routingPath.customerShipList} element={<CustomerShip />} />
            <Route path={routingPath.deliveryList} element={<DeliveryList />} />
            <Route path={routingPath.calendarSetting} element={<CalendarSetting />} />
            <Route path={routingPath.all} element={<Orderlist />} />
          </Routes>
        </Box>
      </Box>
    </>
  );
};
